<template>
    <div>
        <component
            :is="component"
            v-for="(product, index) in offers"
            :key="product.name"
            :product="product"
            :data-cy="`cruise-offer-${index}`"
            :class="contentClass"
            :is-package="isPackage"
        >
            <template v-slot:price="{offer}">
                <slot name="price" :offer="offer" />
            </template>
        </component>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import CruiseCard from '~src/components/cruises/search/offers/CruiseCard.vue'
    import CruiseCardMobile from '~src/components/cruises/search/offers/CruiseCardMobile.vue'

    @Component({
        components: {
            CruiseCard,
            CruiseCardMobile,
        },
    })
    export class CruiseOffers extends Vue {
        @Prop({default: () => []}) offers
        @Prop() contentClass
        @Prop({default: false, type: Boolean}) isPackage

        get component() {
            return this.$breakpoint.smAndDown ? resolveComponent('CruiseCardMobile') : resolveComponent('CruiseCard')
        }
    }

    export default CruiseOffers
</script>
